/**
 * The chosen hub SLUG (not a token, not a secret) — which Keycloak realm the SPA authenticates
 * against (realm-per-hub). Persisted in localStorage so a silent renew / refresh / callback
 * re-derives the same issuer. Access tokens themselves NEVER touch localStorage (sessionStorage
 * only, see oidcConfig.ts).
 */
const HUB_KEY = 'ol.hub';

export function getHub(): string | null {
  try {
    return localStorage.getItem(HUB_KEY);
  } catch {
    return null;
  }
}

export function setHub(slug: string): void {
  try {
    localStorage.setItem(HUB_KEY, slug);
  } catch {
    /* storage unavailable — non-fatal */
  }
}

export function clearHub(): void {
  try {
    localStorage.removeItem(HUB_KEY);
  } catch {
    /* non-fatal */
  }
}

/** Realm naming convention (scripts/dev-smoke-product-api.sh): realm = `opsflow-<slug>`. */
export function realmForHub(slug: string): string {
  return `opsflow-${slug.trim().toLowerCase()}`;
}

/**
 * The hub slug encoded in an issuer URL (`…/realms/opsflow-<slug>`), or null when the issuer's
 * realm does not follow the realm-per-hub convention. Used in the explicit-issuer mode
 * (VITE_OIDC_ISSUER set, HubLogin skipped) so `{hub}`-scoped API paths never fall back to a
 * placeholder tenant.
 */
export function hubFromIssuer(issuer: string): string | null {
  const m = /\/realms\/opsflow-([a-z0-9][a-z0-9._-]*)\/?$/.exec(issuer.trim().toLowerCase());
  return m ? m[1] : null;
}
